// Drawer display modes
export type DrawerDisplayMode = 'compact' | 'expanded' | 'expandedWithSecondary'

// Constants for drawer widths
export const DRAWER_WIDTH = 256
export const COMPACT_DRAWER_WIDTH = 60

// Drawer state interface
export interface DrawerState {
  drawerActive: boolean
  drawerCompact: boolean
  displayMode: DrawerDisplayMode
  isMobile: boolean
  forceHideNav: boolean
}

// Action types
export const TOGGLE_DRAWER = 'drawer/TOGGLE_DRAWER'
export const SET_DRAWER_MODE = 'drawer/SET_DRAWER_MODE'
export const SET_MOBILE_STATE = 'drawer/SET_MOBILE_STATE'
export const SET_FORCE_HIDE_NAV = 'drawer/SET_FORCE_HIDE_NAV'

// Action interfaces
export interface ToggleDrawerAction {
  type: typeof TOGGLE_DRAWER
}

export interface SetDrawerModeAction {
  type: typeof SET_DRAWER_MODE
  payload: DrawerDisplayMode
}

export interface SetMobileStateAction {
  type: typeof SET_MOBILE_STATE
  payload: boolean
}

export interface SetForceHideNavAction {
  type: typeof SET_FORCE_HIDE_NAV
  payload: boolean
}

// Union of all drawer actions
export type DrawerActionTypes =
  | ToggleDrawerAction
  | SetDrawerModeAction
  | SetMobileStateAction
  | SetForceHideNavAction
